import script from "./Income.vue?vue&type=script&lang=ts&setup=true"
export * from "./Income.vue?vue&type=script&lang=ts&setup=true"

import "./Income.vue?vue&type=style&index=0&id=ce21082c&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce21082c"]])

export default __exports__